<template>
  <div class="all_form_block" data-name="experience">
    <div class="block">
      <div class="name_tools">{{ $store.getters.cv_t('work_experience') }}</div>
      <div class="all_form">
        <br>
        <switch-button v-model="$store.state.cv.hasExperience"></switch-button>
        <template v-if="$store.state.cv.hasExperience">
          <div class="inp_info">
            <div class="div_relative active">
              <span v-on:click="$parent.correctLabel($event)">{{$store.getters.cv_t('start')}}</span>
              <datepicker
                name="experience_start"
                v-model="$store.state.cv.tmpExperience.start"
                v-validate="'required'"
                :input-class="errors.first('experience_start') ? 'invalid' : ''"
                :clear-button="true"
                :format="'yyyy.MM'"
                :minimumView="'month'"
                :maximumView="'year'"
                :initialView="'year'"
                :language="$parent.langDatepicker($store.getters.cv_locale)"
                :disabledDates="disabledDatesStart"
                @input="changeStart"
              ></datepicker>
            </div>
            <div class="div_relative active">
              <span v-on:click="$parent.correctLabel($event)">{{$store.getters.cv_t('end')}}</span>
              <datepicker
                name="experience_end"
                v-model="$store.state.cv.tmpExperience.end"
                :clear-button="true"
                :format="'yyyy.MM'"
                :minimumView="'month'"
                :maximumView="'year'"
                :initialView="'year'"
                :language="$parent.langDatepicker($store.getters.cv_locale)"
                :disabledDates="disabledDatesEnd"
              ></datepicker>
            </div>
            <div class="div_relative">
              <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t("company") }}</span>
              <input
                name="experience_company"
                v-validate="'required|min:3|max:255'"
                :class="errors.first('experience_company') ? 'invalid' : ''"
                type="text"
                v-model.trim="$store.state.cv.tmpExperience.company"
                v-on:input="$parent.correctLabel($event)"
                v-on:keyup.tab="$parent.correctLabel($event)"
                v-on:click="$parent.correctLabel($event)"
              >
            </div>
            <div class="div_relative custom">
              <span v-on:click="$parent.correctLabel($event)">{{ $store.getters.cv_t("specialization") }}</span>
              <multiselect
                v-model="value"
                label="title"
                track-by="id"
                :style="customValidStyles('experience_specialization')"
                name="experience_specialization"
                v-validate="'required'"
                :placeholder="$store.getters.cv_t('specialization')"
                :options="option"
                :multiple="false"
                :selectLabel="''"
                :deselectLabel="''"
                :taggable="true"
                :showNoOptions="false"
                @tag="addTag"
                tag-placeholder="+"
              >
                <span slot="noResult">{{$store.getters.cv_t('no_elements')}}</span>
                <span slot="noOptions">{{$store.getters.cv_t('select_empty')}}</span>
              </multiselect>
              <input
                      type="hidden"
                      v-validate="'required'"
                      v-model="value.id"
                      name="experience_specialization"
              >
            </div>
            <div class="div_relative">
              <google-map
                :name="'experience_address'"
                :lat="$store.state.cv.tmpExperience.location.lat"
                :lng="$store.state.cv.tmpExperience.location.lng"
                v-model="$store.state.cv.tmpExperience.location.address"
                :callback="mapResult"
                ref="googleMap"
              ></google-map>
            </div>
            <div class="div_relative">
              <span
                v-on:click="$parent.correctLabel($event)"
              >{{ $store.getters.cv_t("description") }}</span>
              <textarea
                v-model.trim="$store.state.cv.tmpExperience.description"
                v-on:input="$parent.correctLabel($event)"
                v-on:keyup.tab="$parent.correctLabel($event)"
                v-on:click="$parent.correctLabel($event)"
              ></textarea>
            </div>
          </div>
          <div class="add_more">
            <input class="button_style" id="experience" type="button" value @click="add()">
          </div>
        </template>
      </div>
    </div>
    <div class="edit_block_form inp_info" v-if="$store.state.cv.hasExperience">
      <div
        class="div_relative"
        v-for="(experience, index) in $store.state.cv.experiences"
        :key="index"
      >
        <div class="close" @click="$store.state.cv.experiences.splice(index, 1)"></div>
        <div class="edit" @click="edit(index)"></div>
        <div class="organization">
          <p>{{ experience.specialization.title }}</p>
          <p>
            {{ $store.getters.cv_t("at")}}
            <strong>{{ experience.company }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import SwitchButton from "../../../../helpers/switch-button";
import GoogleMap from "./GoogleMap";

export default {
  components: {
    Datepicker,
    Multiselect,
    SwitchButton,
    GoogleMap
  },
  data() {
    return {
      disabledDatesStart: {
        from: new Date()
      },
      disabledDatesEnd: {
        to: this.$store.state.cv.tmpExperience.start
          ? new Date(this.$store.state.cv.tmpExperience.start)
          : null,
        from: new Date()
      },
      model: {
        start: "",
        end: "",
        location: {
          address: "",
          lat: 0,
          lng: 0
        },
        company: "",
        specialization: { id: "", title: "" },
        description: ""
      },
      hasExperience: true,
      custom: [],
      value: this.$store.state.cv.tmpExperience.specialization,
      option: []
    };
  },
  watch: {
    "$parent.professions"(to, from) {
      this.createProfessionOptions(to);
    },
    value(to, from) {
      this.$store.state.cv.tmpExperience.specialization = this.value
        ? this.value
        : {};
    }
  },
  methods: {
    changeStart(data) {
      if (data) {
        this.disabledDatesEnd.to = new Date(data.setMonth(data.getMonth()));
        if (this.$store.state.cv.tmpExperience.end) {
          if (
            this.$store.state.cv.tmpExperience.end.getTime() <
            this.disabledDatesEnd.to.getTime()
          ) {
            this.$store.state.cv.tmpExperience.end = null;
          }
        }
      } else {
        this.$store.state.cv.tmpExperience.end = null;
        this.disabledDatesEnd.to = data;
      }
    },
    mapResult(data) {
      this.$store.state.cv.tmpExperience.location = data;
    },
    add() {
      this.validate().then(res => {
        if (res) {
          if(Number.isInteger(this.$store.state.cv.tmpExperienceEditIndex)){
            this.$store.state.cv.experiences[
                this.$store.state.cv.tmpExperienceEditIndex
                ] = this.$store.state.cv.tmpExperience;
          }else{
            this.$store.state.cv.experiences.unshift({
              ...this.$store.state.cv.tmpExperience
            });
          }
          this.$store.commit('tmpExperienceEditIndex', null);

          this.$store.state.cv.tmpExperience = { ...this.model };
          this.$validator.reset();
          this.$refs['googleMap'].$validator.reset();
          setTimeout(() => {
            this.$parent.correctLabel(false);
          }, 10);
          this.value = {};
        }
      });
    },
    edit(index) {
      this.$store.state.cv.tmpExperience = this.$store.state.cv.experiences[
        index
      ];
      this.value = this.$store.state.cv.experiences[index].specialization;
      // this.$store.state.cv.experiences.splice(index, 1);
      this.$store.commit('tmpExperienceEditIndex', index);
      setTimeout(() => {
        this.$parent.correctLabel(false);
      }, 10);
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then(valid => {
          resolve(valid);
        });
      });
    },
    createProfessionOptions(professions) {
      var option = this.custom.slice();
      for (let profession in professions) {
        let translations = professions[profession]["profession_translations"];
        for (let item in translations) {
          if (this.value.id === professions[profession]["id"]) {
            this.value.title = translations[item]["title"];
            this.$store.state.cv.tmpExperience.specialization = this.value;
          }
          option.push({
            title: translations[item]["title"],
            id: professions[profession]["id"],
            custom: professions[profession]["custom"]
          });
        }
      }
      this.option = option;
    },
    addTag(newTag) {
      const d = new Date();
      const tag = {
        title: newTag,
        id: d.getTime(),
        custom: 1
      };
      this.custom.push(tag);
      this.option.push(tag);
      this.value = tag;
    },
    customValidStyles(name) {
      return this.errors.first(name)
        ? {
            border: "1px solid #d72b2b",
            "border-radius": "7px"
          }
        : {};
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/Experience.vue